//adds offline support
const register = () => {
  if ("serviceWorker" in navigator) {
    // When a new SW takes control, reload once so users get the latest app
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });

    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js").then((registration) => {
        console.log("Service Worker registered with scope:", registration.scope);

        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          installingWorker.onstatechange = () => {
            if (installingWorker.state === "installed") {
              if (navigator.serviceWorker.controller) {
                // New SW installed — skipWaiting() in SW will trigger controllerchange → reload
                console.log("New content available, reloading…");
              }
            }
          };
        };
      }).catch((err) => console.error("Service Worker registration failed:", err));
    });
  }
};

export default register;

